module.exports = __webpack_public_path__ + "static/media/OE-Leonie-dashboard.bd79153e.jpg";